import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PayallService {
  // URL base para endpoints de Payall/Recargas
  // Utiliza BASE_RECHARGE del environment para permitir configuración por ambiente
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.BASE_RECHARGE;
  }

  getBalance(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/recharge/saldo-payall`);
  }

  getTransactionHistory(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/recharge/historial`);
  }

  getLastTransactions(limit: number = 5): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/recharge/ultimas-transacciones?limit=${limit}`);
  }
} 